import React, { useEffect, useState } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Button, CardActions, CardContent, Divider, Grid, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import SkeletonPopularCard from 'ui-component/cards/Skeleton/PopularCard';
import { gridSpacing } from 'store/constant';
import ApiLink from 'API';
import axios from 'axios';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from 'react-router';
import SubCard from 'ui-component/cards/SubCard';
const StockMapingOrder = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [isLoading, setisLoading] = useState(false);
    const [Data, setData] = useState([]);
    const mountedRef = React.useRef(true);

    async function LoadData() {
        try {
            if (!mountedRef.current) return;
            setData([]);
            setisLoading(true);

            const response = await axios.get(ApiLink + '/api/requestproduct/sale/inventory', {
                withCredentials: true,
                headers: { token: localStorage.getItem('token') }
            });
            if (!mountedRef.current) return;
            if (response.status === 200) {
                setData(response.data.data);
                setisLoading(false);
            } else if (response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            if (!mountedRef.current) return;
            console.log(error);
            // Don't auto-logout on network error — was nuking user session for transient failures
            setisLoading(false);
        }
    }
    useEffect(() => {
        mountedRef.current = true;
        LoadData();
        return () => { mountedRef.current = false; };
    }, []);
    return (
        <SubCard
            title="Mapping Stock and Order"
            contentSX={{ p: 0 }}
            show={false}
            secondary={
                <IconButton
                    disabled={isLoading}
                    className="iconbutton"
                    aria-label="refresh"
                    onClick={() => {
                        LoadData();
                    }}
                >
                    <RefreshIcon />
                </IconButton>
            }
        >
            {isLoading ? (
                <SkeletonPopularCard />
            ) : (
                <MainCard>
                    <CardContent>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <Grid container alignContent="center" justifyContent="space-between">
                                    <Grid item>
                                        <Typography variant="h4">Stock & Order</Typography>
                                    </Grid>
                                    {/* <Grid item>
                                        <MoreHorizOutlinedIcon
                                            fontSize="small"
                                            sx={{
                                                color: theme.palette.primary[200],
                                                cursor: 'pointer'
                                            }}
                                            aria-controls="menu-popular-card"
                                            aria-haspopup="true"
                                            onClick={handleClick}
                                        />
                                        <Menu
                                            id="menu-popular-card"
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                            variant="selectedMenu"
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right'
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right'
                                            }}
                                        >
                                            <MenuItem onClick={handleClose}> Today</MenuItem>
                                            <MenuItem onClick={handleClose}> This Month</MenuItem>
                                            <MenuItem onClick={handleClose}> This Year </MenuItem>
                                        </Menu>
                                    </Grid> */}
                                </Grid>
                            </Grid>
                            {/* <Grid item xs={12} sx={{ pt: '16px !important' }}></Grid> */}
                            <Grid item xs={12}>
                                <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 205px)', overflowX: 'hidden' }}>
                                    {Data.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <Grid container direction="column" spacing={gridSpacing}>
                                                    <Grid item>
                                                        <Avatar
                                                            variant="rounded"
                                                            src={item?.images[0]?.img}
                                                            sx={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: '5px',
                                                                // backgroundColor: theme.palette.success.light,
                                                                // color: theme.palette.success.dark,
                                                                ml: 2
                                                            }}
                                                        >
                                                            {/* <KeyboardArrowUpOutlinedIcon fontSize="small" color="inherit" /> */}
                                                        </Avatar>
                                                    </Grid>
                                                    <Grid item>
                                                        <Grid container alignItems="center" justifyContent="space-between">
                                                            <Grid item>
                                                                <Typography variant="subtitle1" color="inherit">
                                                                    {item.productName + ' (' + item.color + ')'}
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item>
                                                                <Typography variant="h3" sx={{ color: 'success.dark' }}>
                                                                    {'Stock: ' + item.qty}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item>
                                                        <Grid container alignItems="center" justifyContent="space-between">
                                                            <Grid item>
                                                                <Typography variant="subtitle2" sx={{ color: 'success.dark' }}>
                                                                    {item.model}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography variant="h3" sx={{ color: 'error.dark' }}>
                                                                    {'Order: ' + item.amount}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Divider sx={{ my: 1.5 }} />
                                            </div>
                                        );
                                    })}
                                </PerfectScrollbar>
                            </Grid>
                        </Grid>
                    </CardContent>
                    {/* <CardActions sx={{ p: 1.25, pt: 0, justifyContent: 'center' }}>
                        <Button size="small" disableElevation>
                            View All
                            <ChevronRightOutlinedIcon />
                        </Button>
                    </CardActions> */}
                </MainCard>
            )}
        </SubCard>
    );
};

export default StockMapingOrder;
